import React, { useState } from "react";
import CustomImage from "../../atoms/customImage";
import PropTypes from "prop-types";
import Typography from "../../atoms/typography";
import Drawer from "../drawer";
import { constants } from "../../../constants/pageConstants/pdpConstants";

/**
 * Offer Card Component that displays a Iamge With content and popOver Information.
 * @param {string} [imageSrc]
 * @param {string} [content]
 * @param {string} [bgColor]
 * @returns {JSX.Element} - Rendered component.
 */
const OffersCard = ({ imageSrc, content, customStyle = {}, tnc, isMobile, dimensions }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  /** */
  const onShowTNC = () => {
    setIsDropdownVisible(true);
  };

  /**
   * Handles closing of the currency dropdown drawer.
   *
   * @returns {void}
   */
  const onDrawerClose = () => {
    setIsDropdownVisible(false);
  };
  return (
    <>
      <div
        className={`relative my-2 flex items-center justify-between rounded-xl border px-12 py-16`}
        style={customStyle}
      >
        <div className="flex w-full items-center justify-between gap-8 md:gap-16">
          <div className="w-[10%]">
            <CustomImage
              src={imageSrc || "https://i1.fnp.com/assets/images/custom/pdp-offer-img/app20.png"}
              width={dimensions?.width || 187}
              height={dimensions?.height || 56}
              alt="offer-image"
              sizes="10vw"
              isPriority={false}
            />
          </div>
          <Typography Tag="p" classes="text-12 xxl:text-14 font-500 text-fnp-500 w-[80%]">
            {content}
          </Typography>
          <button
            className="flex h-[24px] w-[24px] items-center justify-center rounded-full focus:outline-none"
            onClick={onShowTNC}
          >
            <CustomImage
              src="/icons/info-circle-gray.svg"
              width={16}
              height={16}
              alt=""
              sizes="10vw"
              isPriority={false}
            />
          </button>
          {/* {tnc} */}
        </div>
      </div>
      <Drawer
        position={isMobile ? "bottom" : "right"}
        isOpen={isDropdownVisible}
        onDrawerClose={onDrawerClose}
        styles={`px-0 ${isMobile ? "max-h-[80vh]" : "min-w-[360px] max-w-[400px] xll:max-w-[532px] xl:max-w-[400px] h-full"} pt-12 pb-16`}
      >
        <Typography Tag="h4" classes="text-16 font-600 mb-8 pb-16 px-16 border-b-1 border-lightGrey">
          {constants?.TERMS_N_CONDITIONS}
        </Typography>
        <div
          dangerouslySetInnerHTML={{ __html: tnc }}
          id="offerTnc"
          className={`overflow-auto px-16 text-14 scrollbar-thin scrollbar-webkit ${isMobile ? "max-h-[65vh]" : "max-h-[90vh]"}`}
        />
      </Drawer>
    </>
  );
};

OffersCard.propTypes = {
  imageSrc: PropTypes.string,
  content: PropTypes.string,
  customStyle: PropTypes.object,
  tnc: PropTypes.string,
  isMobile: PropTypes.bool,
  dimensions: PropTypes.object,
};

export default OffersCard;
